import events from '@/hooks/events';
import actions from '../constants';

export default {
  useResetVocabulary: (category, { code }) => events.useDispatchByCode(actions.RESET_VOCABULARY, category, code),
  useShowSaveVocabulary: (category, { code }) => events.useDispatchByCode(actions.SHOW_SAVE_VOCABULARY, category, code),
};
